import React from 'react';

export default () => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_18_8333300)">
                <path d="M15.8333 2.66667V6.66667H11.8333" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1.16666 13.3333V9.33333H5.16666" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2.83999 5.99999C3.1781 5.04452 3.75275 4.19026 4.5103 3.51694C5.26786 2.84362 6.18363 2.37317 7.17218 2.1495C8.16073 1.92583 9.18983 1.95622 10.1634 2.23784C11.1371 2.51947 12.0235 3.04314 12.74 3.75999L15.8333 6.66666M1.16666 9.33333L4.25999 12.24C4.97649 12.9569 5.86291 13.4805 6.83653 13.7621C7.81015 14.0438 8.83925 14.0742 9.8278 13.8505C10.8163 13.6268 11.7321 13.1564 12.4897 12.483C13.2472 11.8097 13.8219 10.9555 14.16 9.99999" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_18_8333300">
                    <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>

    );
};
